export const UPLOAD_TYPE = {
  sdkstore: 'sdkstore', // 旧版支付页
  webstorev1: 'webstorev1', // 新版礼包支付页
  webstorev2: 'webstorev2', // 新版代币支付页
  webstorev3: 'webstorev3', // v3支付页
  webstorev35: 'webstorev35', // v3.5支付页
  h5store: 'h5store', // H5支付页
  creditpay: 'creditpay', // 信用卡支付页
  officialPassport: 'officialPassport', // 新版用户中心
  passport: 'passport', // 旧版用户中心
  csorder: 'csorder', // 新版客服工单
  dma: 'dma', // dma弹窗
  webstorev0: 'webstorev0' // 3syua支付页
};
